import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=7e7733cb&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7733cb')) {
      api.createRecord('7e7733cb', component.options)
    } else {
      api.reload('7e7733cb', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=7e7733cb&", function () {
      api.rerender('7e7733cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22zbNVIe4Td3E/JS/stardisplay.vue"
export default component.exports